
<template>
  <form id="formStepShop" data-vv-scope="step-shop">
    <div class="vx-row">
      <div class="vx-col w-full">
        <span>نوع تجارت:*</span>
        <ul class="centerx">
          <li :key="index" v-for="(item, index) in BusinessType">
            <vs-radio
              v-model="
                draftRequest.pspRequestShopAcceptors[0].shop.businessType
              "
              :vs-value="item.value"
              >{{ item.title }}</vs-radio
            >
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          name="shopName"
          label="نام فروشگاه*"
          v-model="draftRequest.pspRequestShopAcceptors[0].shop.farsiName"
          class="w-full mt-4"
        />
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          name="shopNameEn"
          label="Shop Name"
          v-model="draftRequest.pspRequestShopAcceptors[0].shop.englishName"
          class="w-full mt-4"
          style="direction: ltr"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-4" style="font-size: 0.8rem">صنف*</div>
      </div>
      <div class="vx-col w-full">
        <v-select
          :disabled="editForbiden"
          class="selectExample w-full"
          v-model="selectedBusinessCategory"
          @input="getbusinessSubCategoryList"
          :options="businessCategoryList"
        ></v-select>
      </div>
      <div class="vx-col mt-2 w-full">
        <v-select
          :disabled="editForbiden"
          class="selectExample w-full"
          v-model="selectedBusinessSubCategory"
          :options="businessSubCategoryList"
        ></v-select>
      </div>
      <hr />
    </div>
    <div class="vx-row flex-row-reverse">
      <div class="vx-col w-full">
        <vs-input
          label="کد رهگیری مالیاتی"
          v-validate="'numeric'"
          name="taxPayerCode"
          v-model="draftRequest.pspRequestShopAcceptors[0].shop.taxPayerCode"
          class="w-full mt-4 ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-shop.taxPayerCode")
        }}</span>
      </div>
      <div class="vx-col w-full">
        <div class="mt-4 mx-2" style="font-size: 0.8rem">شماره شبا</div>
      </div>
      <div class="vx-col md:w-1/12 pt-3 px-1 f-5">- IR</div>
      <div class="vx-col md:w-11/12 pr-0">
        <vs-input
          v-validate="'digits:24'"
          placeholder="00000000000000000000000"
          v-model="defaultIban"
          name="defaultIban"
          class="w-full mt-1 ltr-input"
        />
        <span class="text-danger text-sm"
          >{{ errors.first("step-shop.defaultIban")
          }}{{
            errors.first("step-shop.defaultIban")
              ? "(24-" + defaultIban.length + ")"
              : ""
          }}</span
        >
      </div>
      <hr />
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-input
          label="شماره جواز کسب"
          v-validate="'numeric'"
          name="businessCertificateNumber"
          v-model="
            draftRequest.pspRequestShopAcceptors[0].shop
              .businessCertificateNumber
          "
          class="w-full mt-4 ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-shop.businessCertificateNumber")
        }}</span>
      </div>
      <div class="vx-col w-full">
        <div class="mt-4" style="font-size: 0.8rem">تاریخ صدور جواز کسب</div>
        <date-picker
          inputClass="py-1 px-5  w-full"
          v-model="certificateIssueDate"
        ></date-picker>
      </div>
      <div class="vx-col w-full">
        <div class="mt-4" style="font-size: 0.8rem">تاریخ اعتبار جواز کسب</div>
        <date-picker
          name="certificateExpiryDate"
          inputClass="py-1 px-5  w-full"
          v-model="certificateExpiryDate"
        ></date-picker>
      </div>
      <hr />
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-4" style="font-size: 0.8rem">نوع مالکیت</div>
        <vs-switch
          v-model="draftRequest.pspRequestShopAcceptors[0].shop.ownershipType"
          style="width: 6em"
          name="isRental"
        >
          <span slot="on">مالک</span>
          <span slot="off">اجاره</span>
        </vs-switch>
      </div>
      <div class="vx-col w-full">
        <div class="mt-4" style="font-size: 0.8rem">
          تاریخ اتمام قرارداد اجاره*
        </div>
        <date-picker
          name="rentalExpiryDate"
          :disabled="
            !draftRequest.pspRequestShopAcceptors[0].shop.ownershipType
          "
          inputClass="py-1 px-5  w-full"
          v-model="rentalExpiryDate"
        ></date-picker>
      </div>
      <div class="vx-col w-full">
        <vs-input
          :disabled="
            !draftRequest.pspRequestShopAcceptors[0].shop.ownershipType
          "
          label="شماره قرارداد اجاره*"
          v-validate="'numeric'"
          name="rentalContractNumber"
          v-model="
            draftRequest.pspRequestShopAcceptors[0].shop.rentalContractNumber
          "
          class="w-full mt-4 ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-shop.rentalContractNumber")
        }}</span>
      </div>
      <hr />
      <div class="vx-col w-full">
        <vs-input
          label="کد پستی*"
          v-validate="{ regex: '^[0-9]{10}$' }"
          name="postalCode"
          v-model="draftRequest.pspRequestShopAcceptors[0].shop.postalCode"
          class="w-full mt-4 ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-shop.postalCode")
        }}</span>
      </div>
      <div class="vx-col w-full">
        <div class="mt-4" style="font-size: 0.8rem">استان*</div>
      </div>
      <div class="vx-col w-full">
        <v-select
          :disabled="editForbiden"
          class="selectExample w-full"
          v-model="selectedProvince"
          @input="getCityList"
          :options="provinceList"
        ></v-select>
      </div>
      <div class="vx-col w-full">
        <div class="mt-4" style="font-size: 0.8rem">شهر*</div>
      </div>
      <div class="vx-col w-full">
        <v-select
          class="selectExample w-full"
          :disabled="editForbiden"
          v-model="selectedCity"
          :options="cityList"
        ></v-select>
      </div>
      <div class="vx-col w-full">
        <vs-input
          name="address"
          v-model="draftRequest.pspRequestShopAcceptors[0].shop.address"
          label="آدرس"
          class="w-full mt-4"
        />
      </div>
      <hr />
      <div class="vx-col w-full">
        <div class="vx-col w-full">
          <div class="mt-4 mb-3" style="font-size: 0.8rem">نوع درگاه:</div>
        </div>
        <vs-radio
          v-for="item in DraftType"
          :key="item.name"
          :vs-value="item.value"
          v-model="draftRequest.type"
          class="mr-4 w-full"
          vs-name="layout-type-vertical"
          >{{ item.title }}</vs-radio
        >
      </div>
      <div class="vx-col w-full mt-4">
        <vs-input
          :disabled="editForbiden"
          label="وبسایت"
          v-validate="{
            regex:
              '^(http:\/\/|https:\/\/)(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$',
          }"
          name="webSite"
          v-model="draftRequest.pspRequestShopAcceptors[0].shop.websiteAddress"
          class="w-full ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-shop.webSite")
        }}</span>
      </div>
      <hr />
      <div class="vx-col w-full">
        <vs-input
          label="تلفن*"
          placeholder="021-00000000"
          v-validate="{ regex: '^0[0-9]{2}-[0-9]{4,8}$' }"
          name="telephoneNumber"
          v-model="draftRequest.pspRequestShopAcceptors[0].shop.telephoneNumber"
          class="w-full mt-4 ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-shop.telephoneNumber")
        }}</span>
      </div>
      <div class="vx-col w-full">
        <vs-input
          label="فکس"
          v-validate="{ regex: '^0[0-9]{2}-[0-9]{4,8}$' }"
          name="fax"
          v-model="draftRequest.draftMerchant.fax"
          class="w-full mt-4 ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-shop.fax")
        }}</span>
      </div>
      <div class="vx-col w-full"></div>
      <div class="vx-col w-full">
        <vs-input
          label="ایمیل*"
          v-validate="{
            regex: '^([1-9a-zA-Z_-]|\.)+@[1-9a-zA-Z_-]+?\.[a-zA-Z]{1,5}$',
          }"
          name="email"
          v-model="draftRequest.pspRequestShopAcceptors[0].shop.emailAddress"
          class="w-full mt-4 ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-shop.email")
        }}</span>
      </div>
      <div class="vx-col w-full">
        <vs-button
          @click="saveShopData"
          class="my-3"
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-save"
          >ذخیره اطلاعات کسب و کار</vs-button
        >
      </div>
    </div>
  </form>
</template>
<style>
hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 110%;
  margin: 12px 0 3px;
}
[dir="rtl"] .ltr-input * {
  direction: ltr;
}
</style>
<script>
const dict = {
  custom: {
    defaultIban: {
      digits: "شبا وارد شده صحیح نمی باشد",
    },
    rentalContractNumber: {
      numeric: "فقط عدد وارد کنید",
    },
    postalCode: {
      regex: "مقدار اشتباه",
    },
    telephoneNumber: {
      regex: "مقدار اشتباه",
    },
    fax: {
      regex: "مقدار اشتباه",
    },
    webSite: {
      regex: "مقدار اشتباه",
    },
    email: {
      regex: "مقدار اشتباه",
    },
  },
};
import Vue from "vue";
Validator.localize("en", dict);

import { Validator } from "vee-validate";
import vSelect from "vue-select";
import { BusinessType, DraftType } from "@/enums.js";
export default {
  name: "edit-shop-data",
  props: {
    draftRequest: {
      default: () => {
        return {
          draftMerchant: {},
          pspRequestShopAcceptors: [{ shop: {} }],
        };
      },
    },
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      BusinessType,
      DraftType,
      businessCategoryList: [],
      selectedBusinessCategory: {},
      businessSubCategoryList: [],
      selectedBusinessSubCategory: {},
      provinceList: [],
      selectedProvince: {},
      cityList: [],
      selectedCity: {},
      certificateIssueDate: "",
      certificateExpiryDate: "",
      rentalExpiryDate: "",
      defaultIban: "",
      editForbiden: false,
    };
  },
  watch: {
    draftRequest: {
      immediate: true,
      handler: async function (n, o) {
        if (!n.id) {
          return;
        }
        this.editForbiden = [13, 5].includes(this.draftRequest.step);
        if (this.draftRequest.draftMerchant.merchantIbans[0].merchantIban)
          this.defaultIban =
            this.draftRequest.draftMerchant.merchantIbans[0].merchantIban.replace(
              "IR",
              ""
            );

        if (!this.businessCategoryList.length)
          await this.getbusinessCategoryList();
        this.selectedBusinessCategory = this.businessCategoryList.find(
          (x) =>
            x.value ==
            this.draftRequest.pspRequestShopAcceptors[0].shop
              .businessCategoryCode
        );
        await this.getbusinessSubCategoryList(this.selectedBusinessCategory);
        this.selectedBusinessSubCategory = this.businessSubCategoryList.find(
          (x) =>
            x.value ==
            this.draftRequest.pspRequestShopAcceptors[0].shop
              .businessSubCategoryCode
        );

        if (!this.provinceList.length) await this.getProvinceList();
        this.selectedProvince = this.provinceList.find(
          (x) =>
            x.value ==
            this.draftRequest.pspRequestShopAcceptors[0].shop.provinceCode
        );
        await this.getCityList(this.selectedProvince);
        this.selectedCity = this.cityList.find(
          (x) =>
            x.value ==
            this.draftRequest.pspRequestShopAcceptors[0].shop.cityCode
        );
        if (
          this.draftRequest.pspRequestShopAcceptors[0].shop
            .certificateIssueDate != null
        )
          this.certificateIssueDate = this.$moment(
            this.draftRequest.pspRequestShopAcceptors[0].shop
              .certificateIssueDate,
            "YYYY/MM/DD"
          ).format("jYYYY/jM/jD");

        if (
          this.draftRequest.pspRequestShopAcceptors[0].shop
            .certificateExpiryDate != null
        )
          this.certificateExpiryDate = this.$moment(
            this.draftRequest.pspRequestShopAcceptors[0].shop
              .certificateExpiryDate,
            "YYYY/MM/DD"
          ).format("jYYYY/jM/jD");
        if (
          this.draftRequest.pspRequestShopAcceptors[0].shop.rentalExpiryDate !=
          null
        )
          this.rentalExpiryDate = this.$moment(
            this.draftRequest.pspRequestShopAcceptors[0].shop.rentalExpiryDate,
            "YYYY/MM/DD"
          ).format("jYYYY/jM/jD");
      },
    },
  },
  methods: {
    saveShopData() {
      if (!this.validateShopData) return;
      let loading = this.$vs.loading();
      const shop = this.draftRequest.pspRequestShopAcceptors[0].shop;
      let payload = {
        id: this.draftRequest.id,
        merchantIban: "IR" + this.defaultIban,
        telephoneNumber: shop.telephoneNumber,
        fax: this.draftRequest.draftMerchant.fax,
        draftType: this.draftRequest.type,
        webSite: shop.websiteAddress,
        shopName: shop.farsiName,
        shopNameEn: shop.englishName,
        postalCode: shop.postalCode,
        businessCertificateNumber: shop.businessCertificateNumber,
        taxPayerCode: shop.taxPayerCode,
        isRental: shop.ownershipType && true,
        rentalContractNumber: shop.rentalContractNumber,
        address: shop.address,
        businessType: shop.businessType,
        email: shop.emailAddress,
      };

      if (this.selectedBusinessCategory && this.selectedBusinessCategory.value)
        payload.businessCategoryCode = this.selectedBusinessCategory.value;

      if (
        this.selectedBusinessSubCategory &&
        this.selectedBusinessSubCategory.value
      )
        payload.businessSubCategoryCode =
          this.selectedBusinessSubCategory.value;

      if (this.selectedProvince && this.selectedProvince.value)
        payload.provinceCode = this.selectedProvince.value;

      if (this.selectedCity && this.selectedCity.value)
        payload.cityCode = this.selectedCity.value;

      if (this.certificateExpiryDate) {
        payload.certificateExpiryDate = this.$moment(
          this.certificateExpiryDate,
          "jYYYY/jMM/jDD"
        ).format();
      }
      if (this.certificateIssueDate) {
        payload.certificateIssueDate = this.$moment(
          this.certificateIssueDate,
          "jYYYY/jMM/jDD"
        ).format();
      }
      if (this.rentalExpiryDate) {
        payload.rentalExpiryDate = this.$moment(
          this.rentalExpiryDate,
          "jYYYY/jMM/jDD"
        ).format();
      }

      this.$http
        .post("/api/services/app/Draft/EditShopData", payload)
        .then((response) => {
          if (response.data.result == true) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "اطلاعات کسب‌و‌کار با موفقیت ذخیره شد",
            });
            this.$vs.loading.close();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    validateShopData() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-shop").then((result) => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    async getbusinessCategoryList() {
      let payload = {
        params: {
          MaxResultCount: 9999,
        },
      };
      await this.$http
        .get("/api/services/app/BusinessCategories/GetAll", payload)
        .then((response) => {
          this.businessCategoryList = response.data.result.items.map((x) => {
            return {
              label: x.businessCategory.description,
              value: x.businessCategory.id,
            };
          });
          this.businessSubCategoryList = [];
        }) //end success
        .catch((error) => {}); //end http
    },
    async getbusinessSubCategoryList(item) {
      if (item == null) return;
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          BusinessCategoryIdFilter: item.value,
          MaxResultCount: 9999,
        },
      };
      await this.$http
        .get("/api/services/app/BusinessSubCategories/GetAll", payload)
        .then((response) => {
          this.selectedBusinessSubCategory = null;
          this.businessSubCategoryList = response.data.result.items.map((x) => {
            return {
              label: x.businessSubCategory.description,
              value: x.businessSubCategory.id,
            };
          });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    async getProvinceList() {
      let payload = {
        params: {
          MaxResultCount: 9999,
        },
      };
      await this.$http
        .get("/api/services/app/Province/GetAll", payload)
        .then((response) => {
          this.provinceList = response.data.result.items.map((x) => {
            return {
              label: x.province.name,
              value: x.province.code,
            };
          });
        }) //end success
        .catch((error) => {}); //end http
    },
    async getCityList(item) {
      if (item == null) return;
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          ProvinceCodeFilter: item.value,
          MaxResultCount: 9999,
        },
      };
      await this.$http
        .get("/api/services/app/City/GetAll", payload)
        .then((response) => {
          this.selectedCity = null;
          this.cityList = response.data.result.items.map((x) => {
            return {
              label: x.city.name,
              value: x.city.code,
            };
          });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
  },
  mounted() {
    this.getbusinessCategoryList();
    this.getProvinceList();
  },
};
</script>